if (sessionStorage.getItem("neobot-boot-seen") === "1") {

document.documentElement.classList.add("boot-seen");

}

document.addEventListener("DOMContentLoaded",()=>{

const button=document.getElementById("enterButton");
const boot=document.getElementById("boot-screen");

if(!boot){

return;

}

if(document.documentElement.classList.contains("boot-seen")){

boot.remove();

return;

}

button.addEventListener("click",()=>{

sessionStorage.setItem("neobot-boot-seen","1");

boot.style.opacity="0";

boot.style.transition="opacity .8s ease";

setTimeout(()=>{

boot.remove();

},900);

});

});
